/**
 * 富文本内容清理工具
 * 用于处理 Word 粘贴内容和接口返回的 HTML，确保表格边框和样式正确显示
 */

/**
 * 清理富文本 HTML 中的 Word/Office 特有样式
 * 处理表格边框、mso- 样式、windowtext 颜色等问题
 * @param {string} html - 原始 HTML 字符串
 * @returns {string} 清理后的 HTML 字符串
 */
function sanitizeHtml(html) {
    if (!html) return html
    try {
        html = html.replace(/<img[^>]*>/gi, match => {
            const src = match.match(/src\s*=\s*["']?([^"'\s>]+)/i)?.[1] || ''
            return src.startsWith('file:') ? '' : match
        })
        html = html.replace(
            /(style|src|href|background|data|sizes)=["'][^"']*file:[^"']*["']/gi,
            ''
        )
        html = html.replace(/<(o|v|w|win):[^>]*>[\s\S]*?<\/\1:[^>]*>/gi, '')
        html = html.replace(/<(o|v|w|win):[^>]*\/?>/gi, '')
        html = html.replace(/<o:p[^>]*>/gi, '')

        // 清理 Word/Office 特有的 mso- 样式和 font 标签
        html = html.replace(/\s*mso-[^;"]+:[^;"]+;*/gi, '')
        html = html.replace(/\s*mso-[^:"']+:[^:"'\s;]*/gi, '')
        html = html.replace(/<font[^>]*>([\s\S]*?)<\/font>/gi, '$1')
        html = html.replace(/<span[^>]*class="Mso[^"]*"[^>]*>([\s\S]*?)<\/span>/gi, '$1')

        // 处理表格 - 清理并添加统一边框
        html = html.replace(/<table([^>]*)>/gi, (match, attrs) => {
            // 移除 w: 开头的 Word XML 属性
            let cleanAttrs = attrs.replace(/\s*w:[^=]+="[^"]*"/gi, '')
            // 移除现有的 border 相关属性
            cleanAttrs = cleanAttrs.replace(/\s*border=["'][^"']*["']/gi, '')
            cleanAttrs = cleanAttrs.replace(/\s*border-width=["'][^"']*["']/gi, '')
            cleanAttrs = cleanAttrs.replace(/\s*border-color=["'][^"']*["']/gi, '')
            cleanAttrs = cleanAttrs.replace(/\s*border-style=["'][^"']*["']/gi, '')
            cleanAttrs = cleanAttrs.replace(/\s*frame=["'][^"']*["']/gi, '')
            cleanAttrs = cleanAttrs.replace(/\s*rules=["'][^"']*["']/gi, '')
            // 保留 width 属性（作为初始宽度）
            cleanAttrs = cleanAttrs.replace(/\s*style=["'][^"']*["']/gi, (style) => {
                // 清理 style 中的边框相关属性
                return style.replace(/border[^;"]*:[^;"]*;*/gi, '')
                          .replace(/mso-[^;"]*:[^;"]*;*/gi, '')
            })
            // 添加默认边框样式
            const finalStyle = 'border-collapse:collapse;border:1px solid #ddd;'
            return `<table${cleanAttrs} class="word-table" style="${finalStyle}">`
        })

        // 处理表格单元格 - 清理并添加统一边框
        html = html.replace(/<t[dh]([^>]*)>/gi, (match, attrs) => {
            // 清理 w: 开头的属性
            let cleanAttrs = attrs.replace(/\s*w:[^=]+="[^"]*"/gi, '')
            // 移除现有的 border 相关属性
            cleanAttrs = cleanAttrs.replace(/\s*border=["'][^"']*["']/gi, '')
            cleanAttrs = cleanAttrs.replace(/\s*border-width=["'][^"']*["']/gi, '')
            cleanAttrs = cleanAttrs.replace(/\s*border-color=["'][^"']*["']/gi, '')
            cleanAttrs = cleanAttrs.replace(/\s*border-style=["'][^"']*["']/gi, '')
            // 清理 style 中的边框相关属性（包含 windowtext 的）
            cleanAttrs = cleanAttrs.replace(/\s*style=["'][^"']*["']/gi, (style) => {
                return style.replace(/border[^;"]*:[^;"]*;*/gi, '')
                          .replace(/border-left[^;"]*:[^;"]*;*/gi, '')
                          .replace(/border-right[^;"]*:[^;"]*;*/gi, '')
                          .replace(/border-top[^;"]*:[^;"]*;*/gi, '')
                          .replace(/border-bottom[^;"]*:[^;"]*;*/gi, '')
                          .replace(/mso-[^;"]*:[^;"]*;*/gi, '')
            })
            // 添加统一边框
            const finalStyle = 'border:1px solid #ddd;padding:6px 10px;vertical-align:middle;'
            return `<td${cleanAttrs} style="${finalStyle}">`
        })

        // 清理多余的空标签
        html = html.replace(/<(p|div|span)[^>]*>\s*<\/\1>/gi, '')

        // 清理连续的 br 标签
        html = html.replace(/(<br\s*\/?>\s*){3,}/gi, '<br>')

        return html
    } catch {
        return html
    }
}

export { sanitizeHtml }
